<template>
    <div class="tab-text">
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Default Language</span>
            </div>
            <vs-select
                v-model="form.defaultlang"
                class="vx-col sm:w-2/3 w-full"
            >
                <vs-select-item
                    :key="index"
                    :value="item.value"
                    :text="item.lang"
                    v-for="(item,index) in defaultlang"
                />
                </vs-select>
        </div>
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Intro Text</span>
                <div style="font-size:0.75rem; color:#aaa;">
                    Shown on the Register page
                </div>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                    class="w-full"
                    v-model="form.intro"
                    :maxLength="600"
                />
            </div>
        </div>
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Instruction for Attendees</span>
                <div style="font-size:0.75rem; color:#aaa;">
                    Shown on the Thank You page after completing the registration and in the ticket email received by attendees
                </div>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input class="w-full" v-model="form.instruction" />
            </div>
        </div>
        <div style="height:10px;"></div>
        <div class="vx-row pt-5 mt-5">
          <div class="vx-col w-full ml-auto">
            <vs-button class="mr-3 mb-2" @click="submitBasic">Submit</vs-button>
            <vs-button v-if="showSellerCancel" class="mr-3 mb-2" type="border" @click="canceled">Cancel </vs-button>
          </div>
        </div>
    </div>
</template>

<script>
import Service from "@/services";

import { timezones } from "@/utils/Timezones";
import { defaultlang } from "@/utils/language";

export default {
    props: [ 'form', 'e' ],
    data() {
        return {
            posterUploadUrl: process.env.VUE_APP_API_URL + "/events/" + this.folder + "/upload",
            posterUploadHeader: {
                Authorization:
                "Bearer " +
                JSON.parse(localStorage.getItem("soldoutt-nimda")).Auth.accessToken
            },
            posterData: {
                type: "poster"
            },
            timezones: timezones,
            defaultlang: defaultlang,
            showSellerCancel: false
        }
    },
    methods: {
        submitBasic() {
            const path = this.$route.path.includes('/sellers/')
            if (path) {
                this.$emit('submitBasic', this.form)
            }
            else {
                this.$vs.loading();
                const formData = new FormData();
                const dataKeyForms = Object.keys(this.form);
                for (let index = 0; index < dataKeyForms.length; index++) {
                    const key = dataKeyForms[index];
                    const value = this.form[key];
                    formData.append(key, value);
                }
                Service.Event.saveMerchant(formData, this.e)
                    .then(res => {
                        this.$vs.loading.close();
                        this.$vs.notify({
                            title: "Success",
                            text: "Update complete.",
                            color: "success"
                        });
                    })
                    .catch(e => {
                        this.$vs.loading.close();
                    });
            }
        },
        canceled() {
            this.$router.push('/sellers')
        }
    },
    mounted() {
        this.showSellerCancel = this.$route.path.includes('/sellers/') ? true: false;
    }
};
</script>
